const mediaQuery = window.matchMedia("(min-width: 1024px)");

const getLayouts = () => {
  const elements = {
    toLeft: document.querySelectorAll(".fade-in-left"),
    toRight: document.querySelectorAll(".fade-in-right"),
  };
  return elements;
};

const validateAnimationElements = (elements) => {
  return elements.toLeft.length > 0 || elements.toRight.length > 0;
};

const setGsapLayOuts = (toRight, toLeft) => {
  gsap.set(toRight, {
    opacity: 0,
    x: -200,
  });

  gsap.set(toLeft, {
    opacity: 0,
    x: 200,
  });
};

const animateElements = (elements) => {
  elements.toLeft.forEach((element) => {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: element,
          start: "-10% 80%",
          end: "40% 60%",
          toggleActions: "play none none none",
          scrub: 1,
        },
      })
      .to(element, {
        opacity: 1,
        x: 0,
        duration: 1,
      });
  });

  elements.toRight.forEach((element) => {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: element,
          start: "-30% 80%",
          end: "bottom 60%",
          toggleActions: "play none none none",
          scrub: 1,
        },
      })
      .to(element, {
        opacity: 1,
        x: 0,
        duration: 1,
      });
  });
};

const fadeLayoutInit = () => {
  const elements = getLayouts();
  if (validateAnimationElements(elements) && mediaQuery.matches) {
    setGsapLayOuts(elements.toRight, elements.toLeft);
    animateElements(elements);
  }
};

export default fadeLayoutInit;
